export default __webpack_public_path__ + "static/media/player-list.1ddcf7ea.svg";